import { reverse } from 'named-urls'

import { routes } from 'SupplierRoutes'
import api from 'service/api'
import {
  COMPANY_SUPPLIER_AUTH_TOKEN,
  COMPANY_SUPPLIER_TOKEN,
  COMPANY_SUPPLIER_PORTAL_TOKEN,
  COMPANY_SUPPLIER_PORTAL_SLUG,
} from 'service/constants'
import * as service from 'service'
import { getWebsiteURL } from 'service/env'

const dponetAPI = api.create('supplierPortal', false)

const login = async ({ token, accessToken, ...params }) => {
  const config = {}

  if (accessToken) {
    config.headers = {
      'X-Suppliers-2FA-Token': accessToken,
    }
  }

  return await dponetAPI.post(`/authentication/${token}`, params, config)
}

const logout = () => {
  removeToken()

  const portalToken = getPortalToken()
  const portalSlug = getPortalSlug()

  if (portalToken && portalSlug) {
    service.history.push(
      reverse(routes.journey, { slug: portalSlug, token: portalToken }),
    )
  } else {
    window.open(getWebsiteURL(), '_self')
  }

  localStorage.removeItem(COMPANY_SUPPLIER_TOKEN)
}

const setToken = (token) => {
  sessionStorage.setItem(COMPANY_SUPPLIER_AUTH_TOKEN, token)
}

const setCompanySupplierToken = (token) => {
  localStorage.setItem(COMPANY_SUPPLIER_TOKEN, token)
}

const getToken = () => {
  const token = sessionStorage.getItem(COMPANY_SUPPLIER_AUTH_TOKEN)
  if (token === 'null') return false
  return token
}

const getCompanySupplierToken = () => {
  const token = localStorage.getItem(COMPANY_SUPPLIER_TOKEN)
  if (token === 'null') return null
  return token
}

const removeToken = () => {
  sessionStorage.removeItem(COMPANY_SUPPLIER_AUTH_TOKEN)
}

const setPortalAccess = ({ slug, token }) => {
  if (slug) localStorage.setItem(COMPANY_SUPPLIER_PORTAL_SLUG, slug)
  if (token) localStorage.setItem(COMPANY_SUPPLIER_PORTAL_TOKEN, token)
}

const getPortalToken = () => {
  const token = localStorage.getItem(COMPANY_SUPPLIER_PORTAL_TOKEN)
  if (token === 'null') return null
  return token
}

const getPortalSlug = () => {
  const slug = localStorage.getItem(COMPANY_SUPPLIER_PORTAL_SLUG)
  if (!slug || slug === 'null') return 'dponet'
  return slug
}

const isAuthenticated = () => {
  const token = getToken()
  return !!token
}

export default {
  getCompanySupplierToken,
  getPortalSlug,
  getPortalToken,
  getToken,
  isAuthenticated,
  login,
  logout,
  setCompanySupplierToken,
  setPortalAccess,
  setToken,
}
